import React from 'react'
import api from "services/api";
import _get from "lodash/get";
import { validaCPF } from './util';
import { useCustomToast } from "hooks/useToast";
import { BeatLoader } from "react-spinners";
import {
  Image,
  Box,
  Select,
} from "@chakra-ui/react";
import { MainButton } from 'components/Button/MainButton';
import {ResgateProps} from '../dominio'
import "../style.scss";
import { Input } from "components/Input";
import { useNavigate } from "react-router-dom";
import Conteudo from 'components/Conteudo';

let step1_Processando: boolean = false;

const Step1 = (props: any) => {
    const pageState: ResgateProps = props.pageState;
    const setPageState = props.setPageState;

    const navigate = useNavigate();

    const { getToast } = useCustomToast();

    const [resgatePontos, setResgatePontos] = React.useState<string>("");
    const [resgateValor, setResgateValor] = React.useState<string>("0.00");
    const [chave, setChave] = React.useState<string>("");
    const [tipoChavePix, setTipoChavePix] = React.useState<string>("");
    const [validated, setValidated] = React.useState<boolean>(false);
    const [debug, setDebug] = React.useState<string>('');
    const [error, setError] = React.useState<any>({});

    const updatePontos = (texto: string) => {
        setResgatePontos(texto);
        const pontos = Number(texto);
        if (isNaN(pontos) || pontos < Number(pageState.resgateMinimo)) {
            setError({...error, pontos: {message: 'Valor inferior ao resgate minimo'}})
            setResgateValor("0.00");
        }
        else if (pontos > Number(pageState.saldo)) {
            setError({...error, pontos: {message: 'Valor maior que seu saldo'}})
            setResgateValor("0.00");
        }
        else {
            setError({...error, pontos: undefined})
            const valor = pontos * 0.7;
            setResgateValor(valor.toFixed(2));
        }
        updateValidate(chave, tipoChavePix);
    }

    const updateChave = (texto: string) => {
        setChave(texto);
        let txtTipo = '';
        if (texto.length < 8) {
            setError({...error, chave: {message: 'Chave pix inválida'}})
            txtTipo = '';
        }
        else {
            setError({...error, chave: undefined});

            if (texto.indexOf('@') >= 0) {
                txtTipo = "email";
            } 
            else if (texto.match(/^[0-9]{11}$/g) !== null) {
                console.log('cpf or celular');
                if (validaCPF(texto) === true)
                    txtTipo = "cpf";
                else 
                    txtTipo = "celular";
            }
            else if (texto.match(/^[0-9a-fA-F\-]{30-36}$/g) !== null)
            {
                txtTipo = "aleatorio";
            }
            else {
                txtTipo = '';
            } 

        }
        setTipoChavePix(txtTipo);
        updateValidate(texto, txtTipo);
    }

    const updateValidate = (txtChave, txtTipo) => {
        const valor = Number(resgateValor);
        if (isNaN(valor) || valor <= 0.01 || txtChave.length < 8 || txtTipo === '') {
            setValidated(false);
        }
        else {
            setValidated(true);
        }
    }

    const setProcessando = (value: boolean) => {
        step1_Processando = value;
        setPageState({...pageState, processando: value});
    }

    const Enviar = async () => {
        if (step1_Processando === true)
            return;
        setValidated(false);
        step1_Processando = true;

        setPageState({...pageState, 
                         processando: true, 
                         resgatePontos: Number(resgatePontos), 
                         resgateValor: Number(resgateValor), 
                         chave: chave,
                         tipoChavePix: tipoChavePix
                    });

        const body: any = {
                "pontos": Number(resgatePontos),
                "chave": chave,
                "resgateRef": pageState.resgateRef,
                "chaveTipo": tipoChavePix
            };
        try {
            const { status, data } = await api.post("/motorDePontos/resgate/pix", body);
            setProcessando(false);
            if (data?.statusId === 2) {
                // vai pro proximo step
                setPageState({...pageState, 
                                    processando: false, 
                                    step: 2, 
                                    bancoDestino: data.bancoDestino,
                                    nomeTitular: data.nomeTitular,
                                    resgatePontos: Number(data.pontos),
                                    chave: chave,
                                    resgateValor: Number(data.valor),
                                    resgateProcessoId: Number(data.resgateProcessoId),
                                    mensagemConfirmacao: data.mensagemConfirmacao
                            });
            }
            else if (data?.statusId === 3) {
                setProcessando(false);
                const message = data.motivoRecusa || 'falha ao processar request';
                setError({...error, chave: {message}});
                getToast({ messageError: message, status: "warning" });
            }
            else {
                // mostra debug
                setDebug(JSON.stringify({status, data, request: body}, null, 2));
            }
            
        } catch (error: any) {
            setProcessando(false);
            const messageError = _get(error, "response.data.errors[0].message") || 'falha ao processar request';
            getToast({ messageError, status: "warning" });
            if (error.response) {
                setDebug(JSON.stringify({status: error.response.status, data: error.response.data, request: body}, null, 2));
            }
            else {
                setDebug(JSON.stringify({error: error.message, stack: error.stack, request: body}, null, 2));
            }
            
            
        } finally {
            updateValidate(chave, tipoChavePix);
        }
    }

    return (
    <Box>
        <div className='resgate_logo'>
            <Conteudo
                tag='site-resgate-pix' 
                tipo='banner' 
                element='Image' 
                alt="Resgate PIX" 
                className='resgate_logo_img' />
        </div>
        <div className='resgate_process_content'>Quantos pontos deseja trocar?</div>
        <div className='resgate_process_content_row_half'>
            <div className='resgate_process_content_col_half_1'><Input 
                nameInput="txt_pontos"
                fontSize="14px"
                label="Digite a quantidade de pontos*"
                error={error.pontos}
                placeholder="000"
                type="number"
                onChange={(e) => updatePontos(e.target.value)}
                value={resgatePontos || ''}
            /></div>
            <div className='resgate_process_content_col_half_2'>
                <div className='labelField'>&nbsp;</div>
                <div className='valorField' style={{color: '#1e641e', fontWeight: '700'}}> = R$ {resgateValor}</div>
            </div>
            
        </div>
        <div className='resgate_process_content_row'>
            <div className='resgate_process_content_col'>
                <Input 
                    nameInput="txt_chave"
                    fontSize="14px"
                    label="Digite sua chave PIX*"
                    error={error.chave}
                    placeholder="chave pix"
                    type="text"
                    onChange={(e) => updateChave(e.target.value)}
                    value={chave || ''}
                />
            </div>
            <div className='resgate_process_content_col'>
                <div className='labelField'>Tipo da chave</div>
                {tipoChavePix === '' && chave === '' &&
                    <div className='valorField'></div>
                }
                {tipoChavePix === '' && chave !== '' &&
                    <div className='valorField'><BeatLoader color='#10125A' size={8} /></div>
                }
                {(tipoChavePix === 'cpf' || tipoChavePix === 'celular')  && 
                    <Select 
                        id='txt_tipo_chave'
                        name='txt_tipo_chave'
                        value={tipoChavePix}
                        onChange={(e) => setTipoChavePix(e.target.value)}
                        style={{marginTop: "8px"}}
                    >
                        <option key='cpf' value='cpf'>cpf</option>
                        <option key='celular' value='celular'>celular</option>
                    </Select>
                }
                {(tipoChavePix === 'email' || tipoChavePix === 'aleatorio') &&
                    <div className='valorField'>{tipoChavePix}</div>
                }
            </div>
        </div>
        <div className='resgate_process_content_row'>
                <MainButton
                    isLoading={pageState.processando}
                    onClick={() => Enviar()}
                    width="240px"  
                    fontSizeButton="20px"  
                    title="Continuar"
                />
                <MainButton
                    isLoading={pageState.processando}
                    onClick={() => navigate("/")}
                    backgroundColorButton="#10125A"
                    width="240px"  
                    fontSizeButton="20px"  
                    title="Voltar"
                />
        </div>
        <div style={{textAlign: 'right', fontSize: '11pt'}}>saldo atual: {pageState.saldo} Ponto(s)</div>
        
    </Box>);
}

export default Step1